import { SxProps, Theme } from "@mui/material";

export const bannerContainerStyles: SxProps<Theme> = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  zIndex: 1000,
  padding: "12px 16px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

export const offlineBannerStyles: SxProps<Theme> = {
  ...bannerContainerStyles,
  backgroundColor: "#ef4444",
  color: "white",
};

export const onlineBannerStyles: SxProps<Theme> = {
  ...bannerContainerStyles,
  backgroundColor: "#22c55e",
  color: "white",
};

export const mainContentStyles: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  flex: 1,
  justifyContent: "center",
};

export const iconStyles: SxProps<Theme> = {
  width: 20,
  height: 20,
  flexShrink: 0,
};

export const messageTextStyles: SxProps<Theme> = {
  fontWeight: 500,
  fontSize: { xs: "12px", sm: "14px" },
  textAlign: "center",
  flex: 1,
  minWidth: 0,
};

export const reloadButtonStyles: SxProps<Theme> = {
  backgroundColor: "white",
  color: "#22c55e",
  padding: { xs: "4px 8px", sm: "4px 16px" },
  borderRadius: "4px",
  fontWeight: 500,
  fontSize: { xs: "12px", sm: "14px" },
  marginLeft: 1,
  flexShrink: 0,
  "&:hover": {
    backgroundColor: "#f3f4f6",
  },
};

export const closeButtonStyles: SxProps<Theme> = {
  color: "white",
  flexShrink: 0,
  marginLeft: 1,
  "&:hover": {
    color: "#e5e7eb",
  },
};

export const closeIconStyles: SxProps<Theme> = {
  width: 20,
  height: 20,
};
